import React, { useEffect } from 'react';
import { FullScreenLoader } from '../../components';
import * as qs from "qs";
import { authEndpoints } from '../../utils/constants/httpConstants';
import EventEmitter from '../../utils/emitter/EventEmitter';
import { EMITTER_ERROR, EMITTER_SUCCESS } from '../../utils/constants';
import { POST } from '../../Apis/apiWrapper';
import { encryptEmail } from '../../utils/helpers';


const ConnectInboxMicrosoftRedirectScreen = () => {

    const parsedObject = qs.parse(window.location.search?.slice(1));


    useEffect(() => {

        (async () => {
            const code = parsedObject.code;
            const tenant_url = localStorage.getItem('inbox_host');
            const tenant_path = localStorage.getItem('tenant_path');
            
            try {
                const payload = {
                    code, tenant_url, esp: 5
                }    
                const encrypedHost = encryptEmail(JSON.stringify( payload ));
                window.location.href = `http://${tenant_url}/user/connect-inbox/${ encrypedHost }?tenant_path=${ encodeURIComponent( tenant_path )}`;

            } catch (error) {
                EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
                window.location.href = `http://${tenant_url}`;
            }finally{
                localStorage.clear();
            }
        })();

    }, []);

    return <FullScreenLoader />
}

export default ConnectInboxMicrosoftRedirectScreen;